import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { post } from "../../lib/request"

// ======================== SEND RESET LINK API ========================
export const sendResetLink = createAsyncThunk(
  "resetPassword/sendResetLink",
  async (payload, { rejectWithValue }) => {
    try {
      const email =
        typeof payload === "string"
          ? payload
          : payload?.email;

      if (!email) {
        throw new Error("Email is required");
      }

      const data = await post(
        `authn/send-reset-link?email=${encodeURIComponent(email)}`,
        undefined,
        { skipAuth: true }
      );

      return data || { code: "RESET_PASSWORD_LINK_SENT", message: "reset password link " };
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
        err?.message ||
        "Failed to send reset link"
      );
    }
  }
);



// ======================== RESET PASSWORD API ========================
export const resetUserPassword = createAsyncThunk(
  "resetPassword/resetUserPassword",
  async ({ token, newPassword }, { rejectWithValue }) => {
    try {
      const data = await post(
        `authn/reset-password/${encodeURIComponent(token)}?new_password=${encodeURIComponent(newPassword)}`,
        undefined,
        { skipAuth: true }
      )
      return data || "Password updated successfully"
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err?.message || "Invalid token or reset failed"
      )
    }
  }
)





// ======================== SLICE ========================
const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState: {
    status: null,
    error: null,
    message: null,
  },
  reducers: {
    clearResetState: (state) => {
      state.status = null
      state.error = null
      state.message = null
    },
  },
  extraReducers: (builder) => {
    // ---- SEND RESET LINK ----
    builder.addCase(sendResetLink.pending, (state) => {
      state.status = "loading"
    })
    builder.addCase(sendResetLink.fulfilled, (state, action) => {
      state.status = "success"
      state.message = action.payload
    })
    builder.addCase(sendResetLink.rejected, (state, action) => {
      state.status = "failed"
      state.error = action.payload
    })

    // ---- RESET PASSWORD ----
    builder.addCase(resetUserPassword.pending, (state) => {
      state.status = "loading"
    })
    builder.addCase(resetUserPassword.fulfilled, (state, action) => {
      state.status = "success"
      state.message = action.payload
    })
    builder.addCase(resetUserPassword.rejected, (state, action) => {
      state.status = "failed"
      state.error = action.payload
    })
  },
})

export const { clearResetState } = resetPasswordSlice.actions
export default resetPasswordSlice.reducer
